import LegalMenu from '@/Components/Menus/LegalMenu.jsx';
import SocialMenu from '@/Components/Menus/SocialMenu.jsx';
import ScrollToTopButton from '@/Components/ScrollToTopButton.jsx';
import PatchNoteModal from '@/Components/AirWater/Modals/PatchNoteModal.jsx';
import {Box, Link as MuiLink, Typography, Button} from '@mui/material';
import {memo, useState} from 'react';
import {usePage, router} from '@inertiajs/react';

const Footer = () => {
    const { url } = usePage();
    const [patchNoteModalOpen, setPatchNoteModalOpen] = useState(false);
    const isProjectsListPage = url === '/projets';

    const handleOpenPatchNoteModal = () => {
        setPatchNoteModalOpen(true);
    };

    const handleClosePatchNoteModal = () => {
        setPatchNoteModalOpen(false);
        // Mettre à jour la préférence utilisateur
        router.patch(route('profile.patch-note-modal.update'), {
            show_patch_note_modal: false
        }, {
            preserveState: true,
            preserveScroll: true,
        });
    };

    return (
        <>
            <PatchNoteModal open={patchNoteModalOpen} onClose={handleClosePatchNoteModal} />
            <Box component="footer" role="contentinfo" sx={footerStyle}>
                <Box sx={footerWrapperStyle}>
                    <Box sx={footerTopStyle}>
                        <Typography variant="h2" component="h2" sx={footerTopHeadingStyle}>
                            Suivez Mitsubishi Electric
                        </Typography>
                        <Box sx={footerTopRsStyle}>
                            <SocialMenu />
                            <Box sx={linkFeatherIconStyle}>
                                <MuiLink
                                    href="https://www.linkedin.com/company/mitsubishi-electric-europe-france/"
                                    color="inherit"
                                    underline="none"
                                    target="_blank"
                                    sx={{fontWeight: 600}}
                                >
                                    Comptes officiels sur les réseaux sociaux
                                </MuiLink>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-chevron-right"
                                    style={{marginLeft: '0.5rem'}}
                                >
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={footerBottomStyle}>
                        <Typography component="span" variant="body1" sx={textStyle}>
                            © Mitsubishi Electric Europe B.V.
                        </Typography>
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                            {/*{isProjectsListPage && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={handleOpenPatchNoteModal}
                                    sx={{
                                        fontSize: '0.875rem',
                                        textTransform: 'none',
                                        borderColor: 'rgba(255, 255, 255, 0.3)',
                                        color: 'inherit',
                                        '&:hover': {
                                            borderColor: 'rgba(255, 255, 255, 0.5)',
                                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                        },
                                    }}
                                >
                                    Nouveautés
                                </Button>
                            )}*/}
                            <LegalMenu />
                        </Box>
                    </Box>
                </Box>
            </Box>
            <ScrollToTopButton />
        </>
    );
};

const footerStyle = (theme) => ({
    color: theme.palette.process_black.main,
    backgroundColor: theme.palette.footer.main,
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1.125rem',
    fontStyle: 'normal',
    fontWeight: 300,
    position: 'relative',
    width: '100%',

    ['@media screen and (max-width: 480px)']: {
        fontSize: '1rem',
    },
});

const footerWrapperStyle = (theme) => ({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: '3.75rem',
    marginInline: 'auto',
    maxWidth: 'calc(1380px + 2rem)',
    paddingBottom: '2.5rem',
    paddingTop: '3.75rem',
    paddingInline: '1rem',
    position: 'relative',
    ['@media (max-width: 640px)']: {
        pt: 10,
        pb: 10,
    },
});

const footerTopStyle = (theme) => ({
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: '.5rem',
    flexDirection: 'column',
    ['@media (max-width: 480px)']: {
        gap: 3,
    },
});

const footerTopHeadingStyle = (theme) => ({
    margin: 0,
    letterSpacing: 'normal',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
});

const footerTopRsStyle = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: '1rem',
    height: '3.625rem',
    ['@media (max-width: 560px)']: {
        flexFlow: 'column nowrap',
        alignItems: 'flex-start',
        height: 'auto',
        gap: 1,
    },
});

const footerBottomStyle = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    ['@media (max-width: 1570px)']: {
        flexFlow: 'column-reverse nowrap',
        alignItems: 'flex-start',
        gap: '2.5rem',
    },
    ['@media (min-width: 800px) and (max-width: 960px)']: {
        pr: 9,
    },
});

const linkFeatherIconStyle = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    ':hover a': {
        color: theme.palette.primary.main,
    },
    ':hover svg': {
        color: theme.palette.primary.main,
    },
});

const textStyle = (theme) => ({
    ...theme.typography.footer,
    whiteSpace: 'nowrap',
    mr: 8,
});
export default memo(Footer);
